import CommonTextInput from "./CommonTextInput";

type TaxCodeInputProps = {
  isMandatory?: boolean;
  labelText?: string;
  inputText?: string | number;
  isDisabled?: boolean;
  name?: string;
  setInputText(inputText: string): void;
};

const TaxCodeTextInput = (props: TaxCodeInputProps) => {

  const setInputTextUpperCase = (inputText: string): void => {
    props.setInputText(inputText.toUpperCase());
  }

  return <CommonTextInput
    name={props.name || props.labelText}
    type="text"
    pattern="^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$"
    isMandatory={props.isMandatory}
    minLength={16}
    maxLength={16}
    labelText={props.labelText}
    inputText={props.inputText}
    isDisabled={props.isDisabled}
    setInputText={setInputTextUpperCase} />
};

export default TaxCodeTextInput;